export enum PRODUCT_TYPES {
  T_SHIRT = "T-SHIRT",
  HOODIE = "HOODIE",
  NO_TYPE = "NO TYPE",
  SOCKS = "SOCKS",
  SWAG_PACK = "SWAG PACK",
  POSTER = "POSTER",
  JACKET = "JACKET",
  GLOVES = "GLOVES",
  SNEAKERS = "SNEAKERS",
  PAINTING = "PAINTING",
  TANK_TOP = "TANK TOP",
  HAT = "HAT",
  SHORTS = "SHORTS",
  SWEATER = "SWEATER",
  ACCESSORIES = "ACCESSORIES",
  SUIT = "SUIT",
  COSTUME = "COSTUME",
  PANTS = "PANTS",
  BACKPACK = "BACKPACK",
  CHAIR = "CHAIR",
  RUG = "RUG",
  SLIPPERS = "SLIPPERS",
  PILLOW = "PILLOW",
  TOWEL = "TOWEL",
  BLANKET = "BLANKET",
  JERSEY = "JERSEY",
  CAP = "CAP",
  BEANIE = "BEANIE",
  LONG_SLEEVE = "LONG SLEEVE",
  UNKNOWN = "UNKNOWN",
  TOP = "TOP",
  DRESS = "DRESS",
  SWEATSHIRT = "SWEATSHIRT",
  VEST = "VEST",
  FLIP_FLOPS = "KLAPKI",
  MYSTERY = "MYSTERY",
  OTHER = "OTHER",
}
